import type { DiscountBanner, StockInfo } from '../../../product/index';
import { Option } from 'effect';

import ProductCardCouponClickableWrapper from '../../client/product/ProductCardCouponClickableWrapper';
import ProductCouponStatic from './ProductCouponStatic';

type Props = {
  productCode: string;
  productName: string;
  discountBanner: DiscountBanner | null;
  price: Option.Option<number>;
  priceWithoutTax: Option.Option<number>;
  stock: StockInfo;
};

export default function ProductCardCoupon({
  productCode,
  productName,
  discountBanner,
  price,
  priceWithoutTax,
  stock,
}: Props) {
  const resolvedPrice = Option.getOrElse(price, () => 0);
  const resolvedPriceWithoutTax = Option.getOrElse(priceWithoutTax, () => 0);

  const maxOrderable = stock.eshop.maxOrderable ?? 0;

  if (
    resolvedPrice === 0 ||
    discountBanner === null ||
    maxOrderable === 0 ||
    discountBanner.style === 'none'
  ) {
    return null;
  }

  if (discountBanner.style === 'clickable') {
    return (
      <ProductCardCouponClickableWrapper
        productCode={productCode}
        productName={productName}
        discountBanner={discountBanner}
        price={resolvedPrice}
        priceWithoutTax={resolvedPriceWithoutTax}
        stock={stock}
      />
    );
  }

  return (
    <ProductCouponStatic
      price={resolvedPrice}
      priceWithCode={discountBanner.money}
      codeName={discountBanner.promo}
    />
  );
}
